import { SUPER_ADMIN_ROLE_CODE } from "../models/adminRole";
import { ADMIN_ROLE_CONFIG, User } from "../models/user";

type SuperAdminUserFields = Pick<User, "adminRoleCode" | "userAdminRole">;

export const isSuperAdminUser = (
  user: SuperAdminUserFields | null | undefined
): boolean => {
  if (!user) {
    return false;
  }

  return (
    user.adminRoleCode === SUPER_ADMIN_ROLE_CODE ||
    user.userAdminRole === ADMIN_ROLE_CONFIG.superAdmin.id
  );
};
